/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
	AppDetailResponseDto,
	AppResponseDto,
	AppUpsertRequestDto,
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class App<SecurityDataType = unknown> {
	http: HttpClient<SecurityDataType>;

	constructor(http: HttpClient<SecurityDataType>) {
		this.http = http;
	}

	/**
	 * No description
	 *
	 * @tags /app
	 * @name DoGetApp
	 * @summary 어플리케이션 리스트
	 * @request GET:/app
	 * @secure
	 * @response `200` `(AppResponseDto)[]` OK
	 * @response `500` `(AppResponseDto)[]` 서버 오류
	 */
	doGetApp = (params: RequestParams = {}) =>
		this.http.request<AppResponseDto[], AppResponseDto[]>({
			path: `/app`,
			method: "GET",
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags /app
	 * @name DoPostApp
	 * @summary 어플리케이션 > 등록 (변경: 2023.08)
	 * @request POST:/app
	 * @secure
	 * @response `200` `AppResponseDto` OK
	 * @response `400` `AppResponseDto` 요청 데이터 확인
	 * @response `404` `AppResponseDto` 현재 사용중인 결제 내역이 없음
	 * @response `409` `AppResponseDto` 패키지명 중복
	 * @response `411` `AppResponseDto` 생성 가능한 앱의 최대 개수 초과
	 * @response `500` `AppResponseDto` 서버 오류
	 */
	doPostApp = (data: AppUpsertRequestDto, params: RequestParams = {}) =>
		this.http.request<AppResponseDto, AppResponseDto>({
			path: `/app`,
			method: "POST",
			body: data,
			secure: true,
			type: ContentType.Json,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags /app
	 * @name DoPatchApp
	 * @summary 어플리케이션 > 수정
	 * @request PATCH:/app
	 * @secure
	 * @response `200` `AppResponseDto` OK
	 * @response `404` `AppResponseDto` 등록된 앱이 없음
	 * @response `409` `AppResponseDto` 패키지명 중복
	 * @response `500` `AppResponseDto` 서버 오류
	 */
	doPatchApp = (data: AppUpsertRequestDto, params: RequestParams = {}) =>
		this.http.request<AppResponseDto, AppResponseDto>({
			path: `/app`,
			method: "PATCH",
			body: data,
			secure: true,
			type: ContentType.Json,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags /app
	 * @name DoGetAppId
	 * @summary 어플리케이션 > 상세
	 * @request GET:/app/{id}
	 * @secure
	 * @response `200` `AppDetailResponseDto` OK
	 * @response `500` `AppDetailResponseDto` 서버 오류
	 */
	doGetAppId = (id: number, params: RequestParams = {}) =>
		this.http.request<AppDetailResponseDto, AppDetailResponseDto>({
			path: `/app/${id}`,
			method: "GET",
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags /app
	 * @name DoDeleteAppId
	 * @summary 어플리케이션
	 * @request DELETE:/app/{id}
	 * @secure
	 * @response `200` `string` OK
	 * @response `303` `string` 사용중인 결제 내역이 있음
	 * @response `404` `string` 등록된 앱이 없음
	 * @response `500` `string` 서버 오류
	 */
	doDeleteAppId = (id: number, params: RequestParams = {}) =>
		this.http.request<string, string>({
			path: `/app/${id}`,
			method: "DELETE",
			secure: true,
			format: "json",
			...params,
		});
}
